/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelPrivacyRequest} from '../api'

export const useMutationCancelPrivacyRequest = createReactQueryMutationHook('cancelPrivacyRequest', cancelPrivacyRequest)
